const NavBarViewModel = () => {
  const menus = [
    { title: "HOME", link: "" },
    { title: "SHOP", link: "" },
    { title: "JOIN", link: "" },
  ];
  return {
    menus,
  };
};

export default NavBarViewModel;
